import { createContext, useContext, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { AppQueryParams } from '../constants';

const ApplicationParamsContext = createContext(null);

export const useApplicationParams = () => {
  const context = useContext(ApplicationParamsContext);

  if (!context) {
    throw new Error(`Error use application params hook outside context provider`);
  }

  return context;
};

export const ApplicationParamsProvider = ({ children }) => {
  const [currentAppVersion, setCurrentAppVersion] = useState(() =>
    localStorage.getItem(AppQueryParams.AppVersion),
  );

  const [currentPlatform, setCurrentPlatform] = useState(() =>
    localStorage.getItem(AppQueryParams.Platform),
  );

  const [currentDeviceId, setCurrentDeviceId] = useState(() =>
    localStorage.getItem(AppQueryParams.DeviceId),
  );

  const [currentUserToken, setCurrentUserToken] = useState(() =>
    localStorage.getItem(AppQueryParams.UserToken),
  );

  const [searchParams] = useSearchParams();

  const platform = searchParams.get(AppQueryParams.Platform);
  const appVersion = searchParams.get(AppQueryParams.AppVersion);
  const deviceId = searchParams.get(AppQueryParams.DeviceId);
  const userToken = searchParams.get(AppQueryParams.UserToken);
  const appSection = searchParams.get(AppQueryParams.AppSection);

  useEffect(() => {
    if (appVersion) {
      setCurrentAppVersion(appVersion);
      localStorage.setItem(AppQueryParams.AppVersion, appVersion);
    }
  }, [appVersion]);

  useEffect(() => {
    if (platform) {
      setCurrentPlatform(platform);
      localStorage.setItem(AppQueryParams.Platform, platform);
    }
  }, [platform]);

  useEffect(() => {
    if (deviceId) {
      setCurrentDeviceId(deviceId);
      localStorage.setItem(AppQueryParams.DeviceId, deviceId);
    }
  }, [deviceId]);

  useEffect(() => {
    if (userToken) {
      setCurrentUserToken(userToken);
      localStorage.setItem(AppQueryParams.UserToken, userToken);
    }
  }, [userToken]);

  return (
    <ApplicationParamsContext.Provider
      value={{
        platform: currentPlatform,
        isWeb: !currentPlatform || currentPlatform === 'web',
        isAndroid: currentPlatform === 'android',
        isIos: currentPlatform === 'ios',
        appVersion: currentAppVersion,
        deviceId: currentDeviceId,
        userToken: currentUserToken,
        appSection,
      }}
    >
      {children}
    </ApplicationParamsContext.Provider>
  );
};
